export default __webpack_public_path__ + "static/media/plans_overlay.67c8ae26.png";